document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      items.forEach(function (otro) {
        otro.classList.remove('mt-abierto');
        var r = otro.querySelector('.mt-faq-respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  var thumbs = document.querySelectorAll('[data-mt-galeria-thumb]');
  if (!principal || !thumbs.length) return;
  var lista = Array.prototype.slice.call(thumbs);
  function centrarMiniatura(thumb) {
    var cont = thumb.parentElement;
    if (!cont || cont.scrollWidth <= cont.clientWidth + 1) return;
    var izq = cont.scrollLeft + (thumb.getBoundingClientRect().left - cont.getBoundingClientRect().left) - (cont.clientWidth - thumb.offsetWidth) / 2;
    cont.scrollTo({ left: izq, behavior: 'smooth' });
  }
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      var img = principal.querySelector('img');
      if (img && src) img.src = src;
      thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
      thumb.classList.add('mt-activo');
      centrarMiniatura(thumb);
    });
  });
  var x0 = null, y0 = null;
  principal.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { x0 = null; return; }
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, { passive: true });
  principal.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var actual = lista.findIndex(function (m) { return m.classList.contains('mt-activo'); });
    var destino = dx < 0 ? actual + 1 : actual - 1;
    if (destino >= 0 && destino < lista.length) lista[destino].click();
  }, { passive: true });
}

function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-producto]');
  if (!wrap) return;
  var dataEl = wrap.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = wrap.querySelector('[data-mt-variant-id]');
  var precioActual = wrap.querySelector('[data-mt-precio-actual]');
  var precioAnterior = wrap.querySelector('[data-mt-precio-anterior]');
  var botonComprar = wrap.querySelector('[data-mt-comprar]');
  var opciones = wrap.querySelectorAll('[data-mt-opcion-grupo]');

  function formatearPrecio(centavos) {
    return (Number(centavos) / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
    });
  }

  function varianteSeleccionada() {
    var seleccion = [];
    opciones.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-seleccionado');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = varianteSeleccionada();
    if (!variante) return;
    if (idInput) idInput.value = variante.id;
    if (precioActual) precioActual.textContent = formatearPrecio(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatearPrecio(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      botonComprar.textContent = variante.available
        ? botonComprar.getAttribute('data-texto-disponible')
        : botonComprar.getAttribute('data-texto-agotado');
    }
    if (variante.media_id) {
      var miniatura = document.querySelector('[data-mt-galeria-thumb][data-media-id="' + variante.media_id + '"]');
      if (miniatura && !miniatura.classList.contains('mt-activo')) miniatura.click();
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variante.available;
      stickyTexto.textContent = variante.available
        ? botonComprar.getAttribute('data-texto-disponible')
        : botonComprar.getAttribute('data-texto-agotado');
      stickyPrecio.textContent = variante.available ? formatearPrecio(variante.price) : '';
      stickyPrecio.previousElementSibling.style.display = variante.available ? '' : 'none';
    }
  }

  var sticky = document.querySelector('[data-mt-sticky]');
  var stickyBtn = sticky && sticky.querySelector('[data-mt-sticky-btn]');
  var stickyTexto = sticky && sticky.querySelector('[data-mt-sticky-texto]');
  var stickyPrecio = sticky && sticky.querySelector('[data-mt-sticky-precio]');
  if (sticky && stickyBtn && botonComprar) {
    var formulario = botonComprar.closest('form');
    stickyBtn.addEventListener('click', function () {
      if (!formulario || stickyBtn.disabled) return;
      if (formulario.requestSubmit) formulario.requestSubmit(botonComprar);
      else formulario.submit();
    });
    var mostrarSticky = function (visible) {
      sticky.classList.toggle('mt-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBtn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('mt-sticky-activo', visible);
    };
    var pendiente = false;
    var evaluarSticky = function () {
      pendiente = false;
      mostrarSticky(botonComprar.getBoundingClientRect().bottom < 0);
    };
    var programarEvaluacion = function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(evaluarSticky);
    };
    window.addEventListener('scroll', programarEvaluacion, { passive: true });
    window.addEventListener('resize', programarEvaluacion);
    evaluarSticky();
  }

  opciones.forEach(function (grupo) {
    grupo.querySelectorAll('[data-valor]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-seleccionado'); });
        boton.classList.add('mt-seleccionado');
        actualizar();
      });
    });
  });
}

function initCantidadProducto() {
  var selector = document.querySelector('[data-mt-cantidad]');
  if (!selector) return;
  var input = selector.querySelector('input');
  var menos = selector.querySelector('[data-mt-menos]');
  var mas = selector.querySelector('[data-mt-mas]');
  if (!input) return;
  if (menos) menos.addEventListener('click', function () {
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  });
  if (mas) mas.addEventListener('click', function () {
    input.value = parseInt(input.value || '1', 10) + 1;
  });
}
